var map = {
	"./EndoPredict_Logo.png": "027f",
	"./Myriad_logo.png": "7ca5",
	"./flags/Australia.png": "c86d",
	"./flags/CE.png": "ecd8",
	"./flags/Canada.png": "ac3c",
	"./flags/Colombia.png": "ea3a",
	"./flags/Dubai.png": "76ab",
	"./flags/EU.png": "fb61",
	"./flags/Mexico.png": "ffb6",
	"./flags/RestOfWorld.png": "0da4",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b9";